// Copyright (c) Docugami, Inc. All rights reserved.
import { ComparisonUnitToken } from "./ComparisonUnitToken";

export class ParagraphInfo {
    public guid: string | null = null;
    public wpElement: any;
    public comparisonUnitTokenList: ComparisonUnitToken[] | null = null;
    public previousParagraphInfo: ParagraphInfo | null = null;
}
